import common from "../../common";
import QuestionInputSelect from "./QuestionInputSelect";

export default class QuestionInputSelectMulti extends QuestionInputSelect {
    constructor(question, view) {
        super(question, view);
        this._selected = [];
    }

    selectOption(option) {
        this._selected.push(option.value);
        this._view.setAnswer(this._selected);
        option.toggle = true;
    }

    deselectOption(option) {
        const ndx = this._selected.indexOf(option.value);
        if (ndx !== -1) {
            this._selected.splice(ndx, 1);
            option.toggle = false;
        }
    }

    /*
    calculateFontSize(options) {
        const min = 14;
        const mid = 18;
        const max = 40;

        for (let i = 0; i < options.length; ++i) {
            const value = options[i];
            const str = value.toString();
            if (str.length >= 8) {
                return min;
            }
            if (str.length >= 4) {
                return mid;
            }
        }
        return max;
    }
    */

    onOptionButtonClick(button) {
        if (this._selected.indexOf(button.value) !== -1) this.deselectOption(button);
        else this.selectOption(button);
    }
}